/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {
  useState, useEffect, useMemo, useRef,
} from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { VariableSizeList as List } from 'react-window';
import styled from '@emotion/styled';
import ResizeObserver from 'react-resize-observer';
import { Field } from 'formik';
import IcomoonReact from 'icomoon-react';
import { useTheme } from 'emotion-theming';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import Input from '../../../../shared/_TBComponents/Input/index';
import SelectBox from '../../../../shared/_TBComponents/SelectBox/index';
import {
  setActiveSecondLayerModal, fetchDocument, addAsset, setQuestionCount,
} from '../../ducks/calendarActions';
import generateUniqueId from '../../../../shared/utils/generateUniqueId';
import { showErrorToast } from '../../../../shared/utils/toastManager';
import useDisplayedDocumentAsset from './hooks/useDisplayedDocumentAsset';

const DescriptionContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const InputsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const AdditionalOptionsHeaderRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const AdditionalOptionsTextAndArrowIconContainer = styled('div')`
 display: flex;
 align-items: center;
 cursor: pointer;
 gap: 8px;
 transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const Seperator = styled('div')`
  display: flex;
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.borderLight};
`;

const InputsSubContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

const StyledTextArea = styled('textarea')`
  width: 100%;
  height: 100%;
  min-height: 82px !important;
  padding: 10px;
  font-size: 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  font-family: 'Nunito Sans';
  color: ${({ theme }) => theme.colors.text};
  background: ${({ theme }) => theme.colors.surfaceInput};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.hover};
    box-shadow: none;
  }
  ::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  :disabled {
    background: ${({ theme }) => theme.colors.surface};
    border-color: ${({ theme }) => theme.colors.borderLight};
    color: ${({ theme }) => theme.colors.textTertiary};
  }
`;

const AddAssetButtonContainer = styled('div')`
  display: flex;
  gap: 4px;
  cursor: pointer;
  align-items: center;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const AssetButtonContainer = styled('div')`
  position: relative;
  display: flex;
  gap: 4px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  cursor: pointer;
  align-items: center;
  border-radius: 4px;
  width: fit-content;
`;

const ClearAssetIconContainer = styled('div')`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.borderMedium};
  padding: 4px;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const NameAndInputContainer = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  .checkbox-input {
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid ${({ theme }) => theme.colors.borderMedium};
    border-radius: 4px;
    outline: none;
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    position: relative;
    transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
  }

  .checkbox-input:checked {
    border: ${(props) => (props.disabled ? `2px solid ${props.theme.colors.borderMedium}` : `2px solid ${props.theme.colors.hover}`)};
   }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: ${(props) => (props.disabled ? `solid ${props.theme.colors.borderMedium}` : `solid ${props.theme.colors.hover}`)};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }
`;

const CheckBoxRow = styled('div')`
 display: flex;
 flex-wrap: wrap;
 gap: 16px;
`;

const ThresholdRow = styled('div')`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const LabelAndCheckBoxContainerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AdditionalOptionsWrapper = styled('div')`
  display: flex;
  gap: 16px;
  margin-top: -9px;
  transition: ${TransitionGlobal};
  overflow: hidden;
  max-height: ${(props) => (!props.showAdditionalOptions ? '0px' : '500px')};
  flex-wrap: wrap;
`;

const AddAssetsColumn = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const QuesitonsDropdownAndRemoveIcon = styled('div')`
  display: flex;
  gap: 16px;
  align-items: center;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: ${TransitionGlobal};
`;

const AddQuestionButton = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed ${({ theme }) => theme.colors.hover};
  border-radius: 4px;
  min-height: 36px;
  max-height: 36px;
  margin-right: ${(props) => props.addMarginRight && '28px'};
  cursor: pointer;
  transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
`;

const NewQuestionButton = styled('div')`
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
`;

const NewQuestionRow = styled('div')`
display: flex;
justify-content: space-between;

`;

const AddQuestionIconAndTextContainer = styled('div')`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const ExerciseManagementWarning = styled('div')`
  display: flex;
  width: fit-content;
  gap: 12px;
  background: ${({ theme }) => theme.colors.warningSurface};
  border: 1px solid ${({ theme }) => theme.colors.warningBorder};
  border-radius: 8px;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 11px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.warningText};
  p {
    font-size: 9pt;
  }
`;

const WarningAndInputContainer = styled('div')`
display: flex;
flex-direction: column;
`;

const IconContainer = styled('div')`
display: flex;
min-width: 16px;
`;

const QuestionnaireFormInputs = ({
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  reusableItemValue,
  trackingValue,
  questionIdValues,
  questions,
  setTouched,
  hasExerciseManagementAccess,
  documentId,
  documentUrl,
  handleChange,
  handleBlur,
  questionnaireThresholdsEnabledValue,
  questionnaireThresholdsInvertedValue,
  questionnaireThresholdLowValue,
  questionnaireThresholdHighValue,
  isManageExercisesContext = false,
}) => {
  const dispatch = useDispatch();
  const { colors } = useTheme();
  const assetToAdd = useSelector((state) => state.calendar.data.addAsset);
  const { displayedAsset, canClear } = useDisplayedDocumentAsset(documentId, documentUrl, assetToAdd);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const accountCode = currentUser?.accountCode;
  const questionsForAccount = useSelector((state) => state.calendar.data.questionsForAccount);
  const [showAdditionalOptions, setShowAdditionalOptions] = useState(true);
  const [addAssetsColumnContainerWidth, setAddAssetsColumnContainerWidth] = useState(0);
  const questionCount = useSelector((state) => state.calendar.data.questionCount);
  const modalData = useSelector((state) => state.calendar.data.modalData);
  const recentlyFetchedExercise = useSelector((state) => state.calendar.data.recentlyFetchedExercise);

  const handleAddQuestion = () => {
    const newQuestion = {
      index: questionCount.length,
      id: `${generateUniqueId()}-null`,
      isNullValue: true,
      isVisible: false, /** Initially hidden, need this for fade in effect */
    };

    /** Add the new question with isVisible: false */
    dispatch(setQuestionCount([...questionCount, newQuestion]));

    setTimeout(() => {
      const updatedQuestionCount = [...questionCount, { ...newQuestion, isVisible: true }];

      /** Second dispatch: Update isVisible to true for the last question so we can fade in opacity */
      dispatch(setQuestionCount(updatedQuestionCount));
    }, 50);
  };

  const handleRemoveQuestion = (question) => {
    dispatch(setQuestionCount(questionCount.map((q) => (q.id === question.id ? { ...q, isVisible: false } : q))));
    setTimeout(() => {
      const updatedQuestionCount = questionCount?.filter((q) => q.id !== question.id);
      dispatch(setQuestionCount(updatedQuestionCount));
      /** wait until item fades out to remove item */
    }, 300);
  };

  useEffect(() => {
    if (assetToAdd) {
      setFieldValue('documentId', assetToAdd?.id);
    }
  }, [assetToAdd]);

  /** keep track of added and removed questions as the user updates, filter questions that have values then
   * map through that array of objects and just return the questionIds to be passed to the form endpoint
   */
  useEffect(() => {
    if (questionCount?.length) {
      const questionsInCountWithValues = questionCount?.filter((questionInCount) => !questionInCount.isNullValue);
      const questionIdValuesToSendWithForm = questionsInCountWithValues.map((questionWithValue) => questionWithValue.id);
      setFieldValue('questionIds', questionIdValuesToSendWithForm);
    }
  }, [questionCount]);

  useEffect(() => {
    /** this is where we are actually setting the initial question values based on the associated quetsions returned form the
     * fetch exercise endpoint
     */
    /** Guard on identity: recentlyFetchedExercise is never cleared between modal
     * opens, so a stale exercise could otherwise seed this form's questions. */
    if (modalData?.editModal && recentlyFetchedExercise
      && String(recentlyFetchedExercise.id) === String(modalData?.itemInfoForEditModal?.id)) {
      const questionIdValuesAssociatedwithExercise = recentlyFetchedExercise?.questions?.map((question) => question.id);
      const updatedQuestions = questionIdValuesAssociatedwithExercise?.map((id, index) => ({
        index,
        id,
        isNullValue: false,
        isVisible: true,
      }));
      dispatch(setQuestionCount(updatedQuestions));
    } else if (questionCount.length === 0) {
      /** if questionCount is empty, initialize with one null */
      dispatch(setQuestionCount([{
        index: 0,
        id: null,
        isNullValue: true,
        isVisible: true,
      }]));
    }
  }, [recentlyFetchedExercise]);

  const InputTypeCheckBoxDataArray = [
    {
      name: 'track',
      label: 'Display Total Value',
      checked: trackingValue,
    },
  ];

  const questionsForAccountOptions = questionsForAccount.map((question) => ({
    name: question.title,
    id: question.id,
  }));

  /** make sure tags always get put in alphabetically order becuase we can make new tags in the dropdown */
  const memoizedQuestionOptions = useMemo(
    () => [...questionsForAccountOptions].sort((a, b) => a.name.localeCompare(b.name)),
    /** create new question redux state needs to be tracked here too when that exists */
    [questionsForAccount, questionIdValues],
  );

  const MenuList = (props) => {
    const { children, maxHeight } = props;
    const listRef = useRef({});
    const rowHeights = useRef({});
    /** Calculate height based on the children length or a default */
    const childrenLengthBy40 = children?.length ? children.length * 40 : 40;
    const height = Math.min(childrenLengthBy40, maxHeight);
    const getRowHeight = (index) => rowHeights.current[index] + 8 || 40;

    return (
      <div style={{ height }}>
        {!children.length ? (
          <List
            ref={listRef}
            height={40}
            itemCount={1}
            itemSize={() => 40}
          >
            {({ style }) => (
              <div style={{
                ...style, display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
              >
                <Text fontSize='16px' color='hsl(0, 0%, 60%)'>No options</Text>
              </div>
            )}
          </List>

        ) : (
          <List
            ref={listRef}
            height={height}
            itemCount={children.length}
            itemSize={(index) => getRowHeight(index)}
          >
            {({ index, style }) => {
              const rowRef = useRef({});

              useEffect(() => {
                if (rowRef.current) {
                  const rowHeight = rowRef.current.getBoundingClientRect().height;
                  /** Store this index's height and reset the List after each update */
                  if (rowHeights.current[index] !== rowHeight) {
                    rowHeights.current[index] = rowHeight;
                    listRef.current?.resetAfterIndex(index); /** Reset from this index to recalculate sizes */
                  }
                }
              }, [index]);

              return (
                <div style={style}>
                  <div ref={rowRef}>
                    {children[index]}
                  </div>
                </div>
              );
            }}
          </List>
        )}
      </div>
    );
  };

  const MemoizedMenuList = React.memo(MenuList);

  const customSelectStylesQuestions = {
    control: (provided, state) => ({
      ...provided,
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 400,
      background: colors.surfaceInput,
      borderColor: state.isFocused ? colors.hover : colors.borderLight,
      boxShadow: state.isFocused ? 'none' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? colors.hover : colors.borderLight,
      },
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '8px 12px',
      backgroundColor: state.isSelected ? colors.surfaceSecondary : colors.surfaceElevated,
      color: state.isSelected ? colors.textTertiary : colors.text,
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: state.data.__isNew__ ? 700 : 400,
      '&:hover': {
        backgroundColor: colors.surfaceSecondary,
      },
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: colors.surfaceSecondary,
      border: `1px solid ${colors.borderLight}`,
      borderRadius: '4px',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: colors.text,
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: colors.textSecondary,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: colors.surfaceElevated,
      color: colors.text,
      border: '0px',
      minWidth: '250px',
      padding: '4px 0',
      marginTop: '0px',
      marginBottom: '0px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: colors.textSecondary,
    }),
    input: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? 'inherit' : provided.color, /** Use 'inherit' to maintain original color */
    }),
  };

  return (
    <InputsContainer>
      <InputsSubContainer>
        <WarningAndInputContainer>
          {!hasExerciseManagementAccess && !modalData?.disabledEditModal && (
            <ExerciseManagementWarning>
              <IconContainer>
                <IcomoonReact
                  iconSet={iconSet}
                  size={16}
                  icon='warning'
                  color='#F59E0B'
                />
              </IconContainer>
              <Text>You do not have the user permissions required to save to the exercise database.</Text>
            </ExerciseManagementWarning>
          )}
          {!isManageExercisesContext && (
          <NameAndInputContainer disabled={modalData?.disabledEditModal || !hasExerciseManagementAccess}>
            <input
              disabled={modalData?.disabledEditModal || !hasExerciseManagementAccess}
              className='checkbox-input'
              type='checkbox'
              name='reusableItem'
              onChange={() => {
                setFieldValue('reusableItem', !reusableItemValue);
                /** if the user goes to uncheck save to database we need to set
               * prSortOrder value back to 0 if there is one and we need to hide
               * prSortOrder as an input option
               */
                if (reusableItemValue) {
                  setFieldValue('prSortOrder', 0);
                }
              }}
              checked={reusableItemValue}
            />
            <Text color={(modalData?.disabledEditModal || !hasExerciseManagementAccess) && colors.textTertiary} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>Save to Database</Text>
          </NameAndInputContainer>
          )}
        </WarningAndInputContainer>
        <DescriptionContainer>
          <Text
            fontSize='16px'
            fontWeight={700}
            color={modalData?.disabledEditModal && colors.textTertiary}
          >
            Description
          </Text>
          <Field
            name='description'
            className='form-control'
            render={({ field }) => (
              <StyledTextArea disabled={modalData?.disabledEditModal} {...field} />
            )}
          />
          {errors.description && (
            <Text color='#CC0404' fontSize='13px' fontWeight={700} style={{ marginTop: '5px' }}>{errors.description}</Text>
          )}
        </DescriptionContainer>
        <NewQuestionRow>
          <Text color={modalData?.disabledEditModal && colors.textTertiary} fontWeight={700} fontSize='16px'>Questions</Text>
          {!modalData?.disabledEditModal && (
          <NewQuestionButton onClick={() => dispatch(setActiveSecondLayerModal('newQuestionForm'))}>
            <IcomoonReact
              iconSet={iconSet}
              size={10}
              icon='plus'
              color='#5F8BDC'
            />
            <Text fontSize='16px' color='#5F8BDC'>New Question</Text>
          </NewQuestionButton>
          )}
        </NewQuestionRow>
        {questionCount?.map((question, index) => (
          <QuesitonsDropdownAndRemoveIcon key={question.id} isVisible={question.isVisible}>
            <SelectBox
              isDisabled={modalData?.disabledEditModal}
              closeOnResize
              /** if the question is already selected in a dropdown, remove it from the options so
               * the user can't select two of the same questions
               */
              options={memoizedQuestionOptions.filter(
                (option) => !questionIdValues?.includes(option.id),
              )}
              value={memoizedQuestionOptions.find((option) => option.id === question.id) || null}
              onChangeFunction={(option) => {
                const updatedQuestionCount = [...questionCount]; /** Make copy to avoid direct mutation */
                updatedQuestionCount[index] = {
                  ...updatedQuestionCount[index],
                  id: parseInt(option.id, 10) || `${generateUniqueId()}-null`, /** Update the id of the current object */
                  isNullValue: !option.id, /** if there is not an id set isNullValue to true, if there is an id set it to false */
                };
                dispatch(setQuestionCount(updatedQuestionCount));
              }}
              onBlur={() => setFieldTouched('questionIds', true)}
              titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
              customStyles={customSelectStylesQuestions}
              isClearable={false}
              menuListComponent={MemoizedMenuList}
              placeholder='Select Question'
            />
            {questionCount?.length > 1 && !modalData?.disabledEditModal && (
              <IcomoonReact
                iconSet={iconSet}
                size={13}
                icon='remove'
                color={colors.textSecondary}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  /** Remove by matching the id */
                  handleRemoveQuestion(question);
                }}
              />
            )}
          </QuesitonsDropdownAndRemoveIcon>
        ))}
        {!!touched.questionIds && !!errors.questionIds && (
        <Text color='#CC0404' fontSize='13px' fontWeight={700} style={{ marginTop: '-10px' }}>{errors.questionIds}</Text>
        )}
        {questionCount?.length < 10 && !modalData?.disabledEditModal && (
        <AddQuestionButton onClick={() => handleAddQuestion()} addMarginRight={questionCount?.length > 1}>
          <AddQuestionIconAndTextContainer>
            <IcomoonReact
              iconSet={iconSet}
              size={10}
              icon='plus'
              color='#5F8BDC'
            />
            <Text fontSize='16px' color='#5F8BDC'>Add Question</Text>
          </AddQuestionIconAndTextContainer>
        </AddQuestionButton>
        )}
        <AddAssetsColumn>
          <ResizeObserver
            onResize={(rect) => {
              setAddAssetsColumnContainerWidth(rect?.width);
            }}
          />
          {modalData?.disabledEditModal ? null : (
            <Text fontSize='16px' fontWeight={700}>Attach Document/Link</Text>
          )}
          {displayedAsset ? (
            <AssetButtonContainer onClick={() => {
              const docId = displayedAsset?.id;
              if (displayedAsset.type === 1) {
                dispatch(fetchDocument(({ accountCode, docId }), {
                  onSuccess: (response) => {
                    window.open(response?.url, '_blank');
                  },
                  onError: () => {
                    showErrorToast('Opps! Something went wrong. Unable to fetch document.');
                  },
                }));
              }
              if (displayedAsset.type === 2) {
                window.open(displayedAsset?.url, '_blank');
              }
            }}
            >
              {canClear && (
              <ClearAssetIconContainer onClick={(e) => {
                dispatch(addAsset(null));
                setFieldValue('documentId', 0);
                setFieldValue('documentUrl', null);
                e.stopPropagation();
              }}
              >
                <IcomoonReact
                  iconSet={iconSet}
                  size={10}
                  icon='remove'
                  color={colors.textSecondary}
                />
              </ClearAssetIconContainer>
              )}
              <IcomoonReact
                iconSet={iconSet}
                size={14}
                icon='link'
                color={colors.textSecondary}
              />
              <Text
                style={{
                  maxWidth: `${addAssetsColumnContainerWidth - 60}px`,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
                fontSize='16px'
                color={colors.textSecondary}
              >
                {displayedAsset?.name}
              </Text>
            </AssetButtonContainer>
          ) : (
            <>
              {!modalData?.disabledEditModal && (
                <AddAssetButtonContainer onClick={() => dispatch(setActiveSecondLayerModal('addAssetModal'))}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={12}
                    icon='plus'
                    color={colors.hover}
                  />
                  <Text fontSize='16px' color={colors.hover}>Add Asset</Text>
                </AddAssetButtonContainer>
              )}
            </>
          )}
        </AddAssetsColumn>
      </InputsSubContainer>
      <AdditionalOptionsHeaderRow>
        <Seperator />
        <AdditionalOptionsTextAndArrowIconContainer onClick={() => setShowAdditionalOptions(!showAdditionalOptions)}>
          <Text fontSize='18px' color={colors.textSecondary} style={{ minWidth: '210px' }}>Exercise Default Settings</Text>
          <IcomoonReact
            iconSet={iconSet}
            size={8}
            icon={showAdditionalOptions ? 'up-arrow' : 'down-arrow'}
            color={colors.textSecondary}
          />
        </AdditionalOptionsTextAndArrowIconContainer>
        <Seperator />
      </AdditionalOptionsHeaderRow>
      {showAdditionalOptions && (
        <Text fontSize='14px' color={colors.textSecondary} style={{ marginTop: '-8px' }}>Any items checked below will be active when adding this exercise to a workout</Text>
      )}
      <AdditionalOptionsWrapper showAdditionalOptions={showAdditionalOptions}>
        <LabelAndCheckBoxContainerWrapper>
          {/* <Text color={modalData?.disabledEditModal && colors.textTertiary} fontWeight={700} fontSize='16px'>Tracking</Text> */}
          <CheckBoxRow>
            {InputTypeCheckBoxDataArray.map((option) => (
              <NameAndInputContainer disabled={modalData?.disabledEditModal}>
                <input
                  disabled={modalData?.disabledEditModal}
                  className='checkbox-input'
                  type='checkbox'
                  name={option.name}
                  onChange={() => {
                    setFieldValue(`${option.name}`, !option.checked);
                  }}
                  checked={option.checked}
                />
                <Text color={modalData?.disabledEditModal && colors.textTertiary} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>{option.label}</Text>
              </NameAndInputContainer>
            ))}
            {!!trackingValue && (
              <NameAndInputContainer disabled={modalData?.disabledEditModal}>
                <input
                  disabled={modalData?.disabledEditModal}
                  className='checkbox-input'
                  type='checkbox'
                  name='questionnaireThresholdsEnabled'
                  onChange={() => {
                    const nextValue = !questionnaireThresholdsEnabledValue;
                    setFieldValue('questionnaireThresholdsEnabled', nextValue);
                    if (!nextValue) {
                      setFieldValue('questionnaireThresholdsInverted', false);
                      setFieldValue('questionnaireThresholdLow', null);
                      setFieldValue('questionnaireThresholdHigh', null);
                    }
                  }}
                  checked={questionnaireThresholdsEnabledValue}
                />
                <Text color={modalData?.disabledEditModal && colors.textTertiary} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>Enable reporting thresholds on total</Text>
              </NameAndInputContainer>
            )}
          </CheckBoxRow>
          {!!trackingValue && !!questionnaireThresholdsEnabledValue && (
            <>
              <ThresholdRow>
                <Input
                  error={!!touched.questionnaireThresholdLow && !!errors.questionnaireThresholdLow}
                  errorMsg={errors.questionnaireThresholdLow}
                  fontSize='16px'
                  fontWeight={400}
                  textColor='#444444'
                  height='38px'
                  label='Lower Threshold'
                  name='questionnaireThresholdLow'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  right='5px'
                  styledPropsLabel={{
                    fontSize: '16px',
                    fontWeight: 700,
                  }}
                  styledPropsWrapper={{
                    flex: 1,
                    minWidth: 136,
                    maxWidth: 226,
                  }}
                  top='38px'
                  value={questionnaireThresholdLowValue}
                  width='100%'
                />
                <Input
                  error={!!touched.questionnaireThresholdHigh && !!errors.questionnaireThresholdHigh}
                  errorMsg={errors.questionnaireThresholdHigh}
                  fontSize='16px'
                  fontWeight={400}
                  textColor='#444444'
                  height='38px'
                  label='Upper Threshold'
                  name='questionnaireThresholdHigh'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  right='5px'
                  styledPropsLabel={{
                    fontSize: '16px',
                    fontWeight: 700,
                  }}
                  styledPropsWrapper={{
                    flex: 1,
                    minWidth: 136,
                    maxWidth: 226,
                  }}
                  top='38px'
                  value={questionnaireThresholdHighValue}
                  width='100%'
                />
              </ThresholdRow>
              <NameAndInputContainer disabled={modalData?.disabledEditModal}>
                <input
                  disabled={modalData?.disabledEditModal}
                  className='checkbox-input'
                  type='checkbox'
                  name='questionnaireThresholdsInverted'
                  onChange={() => setFieldValue('questionnaireThresholdsInverted', !questionnaireThresholdsInvertedValue)}
                  checked={questionnaireThresholdsInvertedValue}
                />
                <Text color={modalData?.disabledEditModal && colors.textTertiary} fontSize='16px'>Invert thresholds (lower values are preferred)</Text>
              </NameAndInputContainer>
            </>
          )}
        </LabelAndCheckBoxContainerWrapper>
      </AdditionalOptionsWrapper>
    </InputsContainer>
  );
};

export default QuestionnaireFormInputs;
